module.exports = __webpack_public_path__ + "static/media/isoLogo-light.2fa3135b.svg";